import { render, staticRenderFns } from "./quicklyOrder.vue?vue&type=template&id=b41927ae&scoped=true"
import script from "./quicklyOrder.vue?vue&type=script&lang=js"
export * from "./quicklyOrder.vue?vue&type=script&lang=js"
import style0 from "./quicklyOrder.vue?vue&type=style&index=0&id=b41927ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41927ae",
  null
  
)

export default component.exports